import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { TweaksPanel } from './TweaksPanel';
import { SearchChatPanel } from './SearchChatPanel';
import { RightChatPanel } from './RightChatPanel';
import type { User } from '@/types/api';

interface AppShellProps {
  me: User;
}

// The authenticated app shell: sticky sidebar + top bar, route content in the
// main column, persistent tweaks drawer.
export function AppShell({ me }: AppShellProps) {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--apm-bg)' }}>
      <Sidebar />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Topbar me={me} />
        <main
          style={{
            flex: 1,
            padding: 'var(--apm-page-top) var(--apm-page-pad) var(--apm-section-gap)',
            maxWidth: 1280,
            width: '100%',
            margin: '0 auto',
          }}
        >
          <Outlet />
        </main>
      </div>
      <TweaksPanel />
      <SearchChatPanel />
      <RightChatPanel />
    </div>
  );
}
